import classNames from "classnames";
import { FunctionComponent } from "react";
import RadioButton from "rivals/components/shared/Form/RadioButton/index";
import styles from "./index.module.scss";
import { OwnProps } from "./types";

const PromoCard: FunctionComponent<OwnProps> = ({
  cardPromo,
  footer,
  hasFancyBackground = false,
  info,
  onClick,
  opt,
  radioLabel,
  sectionPromo,
  selectedPromo
}) => {
  return (
    <div
      className={classNames(styles.sectionContainer, {
        [styles.fancyContainer]: hasFancyBackground
      })}
      onClick={(): void => onClick(opt)}
    >
      {!!sectionPromo && (
        <div className={styles.sectionPromo}>{sectionPromo}</div>
      )}
      <div
        className={classNames(styles.detailsContainer, {
          [styles.selectedDetailsContainer]: selectedPromo === opt
        })}
      >
        {!!cardPromo && <div className={styles.cardPromo}>{cardPromo}</div>}
        <div className={styles.detailsWrapper}>
          <RadioButton
            className={styles.radioButton}
            data={`subscription-plan-${opt}-radio`}
            disabled={false}
            isChecked={selectedPromo === opt}
            name={opt}
            onChange={(): void => onClick(opt)}
            value={opt}
          />
          <div>
            <div className={styles.radioLabel}>{radioLabel}</div>
            {info && <div className={styles.info}>{info}</div>}
          </div>
        </div>

        {footer && (
          <>
            <hr />
            <div className={styles.footer}>{footer}</div>
          </>
        )}
      </div>
    </div>
  );
};

export default PromoCard;
